import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ma-3 text-body-2 text-grey" }
const _hoisted_2 = {
  key: 1,
  class: "ma-3 d-flex flex-column",
  style: {"gap":"0.75rem"}
}
const _hoisted_3 = { class: "text-subtitle-2 font-weight-bold mt-2 mb-1 text-grey-darken-2" }
const _hoisted_4 = { class: "text-caption text-grey" }
const _hoisted_5 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_6 = { class: "text-body-1 font-weight-bold" }
const _hoisted_7 = {
  class: "mt-1 d-flex align-center flex-wrap text-caption text-grey",
  style: {"gap":"0.5rem 1rem"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "text-caption text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_ai_report_status_chip = _resolveComponent("ai-report-status-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      flat: "",
      app: "",
      dark: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          style: {"position":"absolute"},
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "large",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content","font-size":"14px"} }, {
          default: _withCtx(() => [
            _createTextVNode(" VEVOレポート - " + _toDisplayString(_ctx.monthsLabel || `第${_ctx.quarter}Q`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.year) + "年度・第" + _toDisplayString(_ctx.quarter) + "クォーター (" + _toDisplayString(_ctx.monthsLabel) + ") ", 1),
        (_ctx.isFetching)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary"
            }))
          : _createCommentVNode("", true),
        (_ctx.quarterDetail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quarterDetail.classes, (cls) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: cls.classId
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(cls.className) + " ", 1),
                    _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(cls.ageLabel) + " / " + _toDisplayString(cls.children.length) + "名)", 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cls.children, (c) => {
                    return (_openBlock(), _createBlock(_component_v_card, {
                      key: c.childId,
                      variant: "outlined",
                      class: _normalizeClass(["pa-3", { 'ai-report-card--clickable': c.status !== 'notGenerated' }]),
                      onClick: ($event: any) => (_ctx.toDetail(c.childId))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_ai_report_status_chip, {
                            status: c.status
                          }, null, 8, ["status"]),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(c.lastName) + " " + _toDisplayString(c.firstName), 1),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("mdi-chevron-right", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", null, "達成項目数: " + _toDisplayString(c.achievedItemCount) + "個", 1),
                          _createElementVNode("span", null, "経過記録数: " + _toDisplayString(c.progressRecordCount) + "件", 1),
                          (c.status !== 'notGenerated')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 生成回数: " + _toDisplayString(c.generationCount) + "回 ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        (c.lastPublishedAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 公開日: " + _toDisplayString(_ctx.formatDate(c.lastPublishedAt)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"]))
                  }), 128))
                ], 64))
              }), 128)),
              (_ctx.quarterDetail.classes.length === 0)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "info",
                    variant: "outlined"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode(" 対象クォーターのクラスがありません。 ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}